import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
import InboxRadarShareableReport from './inbox-radar-shareable-report';
import {
  getShareableReportDataRequest,
  getShareableReportSenderEmailAccountsRequest,
} from '../../extra-actions';
import { GetShareableReportDataPayload, GetShareableReportSenderEmailAccountsPayload } from '../../types';
import {
  resetGetShareableReportDataRequest,
  resetGetShareableReportSenderEmailAccountsRequest,
} from '../../inbox-radar-slice';
import { getAgencyConfigRequest } from '../../../home/extra-actions';

const mapStateToProps = (state: RootState) => ({
  agencyConfigRequestStatus: state.home?.getAgencyConfigRequest.status,
  getShareableReportDataRequestStatus: state.inboxRadar.getShareableReportDataRequest.status,
  getShareableReportSenderEmailAccountsRequestStatus: state.inboxRadar.getShareableReportSenderEmailAccountsRequest.status,
  
  getShareableReportDataRequestError: state.inboxRadar.getShareableReportDataRequest.error,
  getShareableReportSenderEmailAccountsRequestError: state.inboxRadar.getShareableReportSenderEmailAccountsRequest.error,
  
  agencyConfig: state.home?.agencyConfig,
  getShareableReportDataResponse: state.inboxRadar.getShareableReportDataResponse,
  getShareableReportSenderEmailAccountsResponse: state.inboxRadar.getShareableReportSenderEmailAccountsResponse,
});

const mapDispatchToProps = {
  sendGetAgencyConfigRequest: (agencyConfigPayload: {
    baseUrl: string;
    email?: string;
  }) => getAgencyConfigRequest(agencyConfigPayload),
  
  sendGetShareableReportDataRequest: (seedTemplateId: string, payload: GetShareableReportDataPayload) =>
    getShareableReportDataRequest({ seedTemplateId, payload }),
  sendGetShareableReportSenderEmailAccountsRequest: (seedTemplateId: string, payload: GetShareableReportSenderEmailAccountsPayload) =>
    getShareableReportSenderEmailAccountsRequest({ seedTemplateId, payload }),

  resetGetShareableReportDataRequest: () => resetGetShareableReportDataRequest(),
  resetGetShareableReportSenderEmailAccountsRequest: () => resetGetShareableReportSenderEmailAccountsRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(InboxRadarShareableReport);
